module.exports = __webpack_public_path__ + "static/img/01bg.e19f9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/01bg.png
// module id = LZwr
// module chunks = 1